import { COMPLIANCE_TERMS_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useComplianceTermsList } from './hook';
import { ComplianceTermsListProps } from './props';

export const ComplianceTermsList = ({ filters }: ComplianceTermsListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useComplianceTermsList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item, event) => {
                if (!(event.target as Element).closest('.no-click-cell')) {
                    window.open(
                        `${COMPLIANCE_TERMS_DETAIL}/${item.row.id}`,
                        '_blank'
                    );
                }
            }}
        />
    );
};
